import React from "react";
import { DropdownItem, Button } from "reactstrap";
import "./notifications.css";
import { withRouter } from "react-router-dom";
import { updateConsultStatus } from "../../providers/chatProvider";

class VideoNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
  }

  accept = async ref => {
    //respondRequest(ref,true);
    this.props.history.push(`/video/${ref}`);
  };

  decline = async ref => {
    console.log(ref);

    //respondRequest(ref,false);
    const result = await updateConsultStatus(ref, "canceled", this.props.token);
    if (result.error) return;
    this.props.removeNotification(ref);
  };

  renderRequests() {
    if (!this.props.videos) return null;
    return (
      <React.Fragment>
        {this.props.videos.map((item, index) => {
          return (
            <div className="notification-item" key={`notification-${index}`}>
              <div className="notification-header">
                Nova solicitação de videochamada
              </div>
              <div className="notification-body">
                {item.customerId.firstName} {item.customerId.lastName} <br />
              </div>
              <div className="notification-footer">
                <Button
                  size="sm"
                  color="success"
                  onClick={() => this.accept(item._id)}
                >
                  Aceitar
                </Button>
                <Button
                  className="ml-2"
                  size="sm"
                  color="danger"
                  onClick={() => this.decline(item._id)}
                >
                  Recusar
                </Button>
              </div>
            </div>
          );
        })}
        {this.props.videos.length === 0 ? (
          <DropdownItem>Não há solicitações de videochamada</DropdownItem>
        ) : null}
      </React.Fragment>
    );
  }

  render() {
    if (!this.props.videos === 0)
      return (
        <DropdownItem>Não há novas solicitações de videochamadas</DropdownItem>
      );

    return <React.Fragment>{this.renderRequests()}</React.Fragment>;
  }
}

export default withRouter(VideoNotifications);
